export const brand = {
  name: "MINDSCOPE",
  taglineSanskrit: "स्पष्टतया पूंजी, आत्मविश्वासेन वृद्धिः",
  taglineEnglish: "Capital with clarity. Growth with confidence.",
  positioning: "India's trusted capital partner for visionary founders, industry leaders and purpose-led enterprises.",
};

export const ethos = [
  {
    num: "01",
    title: "Radical Trust",
    body: "We build relationships as long-tenured as the capital we shepherd — measured in decades, not deal cycles.",
  },
  {
    num: "02",
    title: "Uncompromising Integrity",
    body: "Every recommendation is regulator-ready, board-defensible, and aligned with fiduciary conscience.",
  },
  {
    num: "03",
    title: "Intentional Growth",
    body: "We do not chase scale. We architect it — with staged milestones, disciplined leverage and repeatable playbooks.",
  },
  {
    num: "04",
    title: "Strategic Clarity",
    body: "We translate complexity into a single page. Boards act faster when the frame is honest and the math is naked.",
  },
  {
    num: "05",
    title: "National Catalyst",
    body: "We commit ourselves to India's public-market maturity — enabling first-time issuers to enter with grace and rigor.",
  },
  {
    num: "06",
    title: "Absolute Discretion",
    body: "Sensitive conversations remain sensitive. Our confidentiality is not a policy line — it is our practice architecture.",
  },
];

export const services = [
  { num: "01", title: "Rights Issue", desc: "Structured equity-raise for existing shareholders — from board approval through allotment and listing.", tag: "Equity" },
  { num: "02", title: "IPO", desc: "End-to-end initial public offering advisory: DRHP drafting, SEBI liaison, roadshow orchestration.", tag: "Public Markets" },
  { num: "03", title: "NCD", desc: "Non-Convertible Debenture issuance for institutional and retail capital — public and private placement.", tag: "Debt" },
  { num: "04", title: "Preferential Issue", desc: "Targeted equity or warrant placement to strategic investors under SEBI ICDR compliance.", tag: "Equity" },
  { num: "05", title: "Buy Back of Shares", desc: "Tender-offer and open-market buyback structuring for capital-return and EPS optimisation.", tag: "Capital Return" },
  { num: "06", title: "Delisting", desc: "Voluntary delisting from stock exchanges — reverse book-building through post-offer compliance.", tag: "Strategic Exit" },
  { num: "07", title: "OFS", desc: "Offer for Sale execution for promoter divestment or minimum public shareholding compliance.", tag: "Public Markets" },
  { num: "08", title: "Bonus Issue", desc: "Capitalisation of reserves through bonus share issuance — with tax and treasury alignment.", tag: "Equity" },
  { num: "09", title: "AIF Registration", desc: "Category I, II and III Alternative Investment Fund setup, PPM drafting and SEBI registration.", tag: "Funds" },
  { num: "10", title: "Revocation of Suspension", desc: "Restoration of trading in suspended scrips — compliance remediation and exchange dialogue.", tag: "Advisory" },
  { num: "11", title: "Direct Listing", desc: "Direct-to-exchange listing for eligible entities without a public offering.", tag: "Public Markets" },
  { num: "12", title: "Migration – SME to Main Board", desc: "Guided uplift from SME platforms to NSE / BSE Main Board with governance readiness.", tag: "Growth" },
  { num: "13", title: "Listing Regulation Advisory", desc: "Ongoing SEBI (LODR) advisory — disclosures, related-party framework, insider trading code.", tag: "Advisory" },
  { num: "14", title: "Stock Split", desc: "Face-value sub-division to improve retail participation and market-lot accessibility.", tag: "Capital Structure" },
  { num: "15", title: "QIP", desc: "Qualified Institutional Placement — accelerated capital raise from institutional investors.", tag: "Equity" },
  { num: "16", title: "Compulsory Convertible Debentures", desc: "CCD structuring — hybrid instrument that mandatorily converts to equity on defined triggers; used for staged fundraising and investor alignment.", tag: "Hybrid" },
  { num: "17", title: "Optionally Convertible Debentures", desc: "OCD issuance with issuer- or holder-optional conversion features; ideal where flexibility on the debt-to-equity path matters.", tag: "Hybrid" },
  { num: "18", title: "Partially Convertible Debentures", desc: "PCD design — part of the face value converts to equity while the balance behaves as debt with fixed coupon.", tag: "Hybrid" },
  { num: "19", title: "Merger & Amalgamation", desc: "End-to-end scheme drafting, valuation, NCLT petition and stakeholder liaison for mergers, amalgamations and demergers.", tag: "M&A" },
  { num: "20", title: "Share Swap", desc: "Consideration-in-kind transaction structuring — equity swap ratios, valuation defence, and regulatory approvals.", tag: "M&A" },
  { num: "21", title: "Reverse Listing", desc: "Backdoor entry to public markets via acquisition of a listed shell — end-to-end scheme, SEBI liaison and post-merger compliance.", tag: "Public Markets" },
  { num: "22", title: "Bank Syndication", desc: "Structuring and placement of term loans, working-capital lines and consortium arrangements with domestic and multilateral lenders.", tag: "Debt" },
  { num: "23", title: "SME Listing", desc: "Full-service SME IPO execution on NSE Emerge / BSE SME — issuer readiness, DRHP, marketing and listing.", tag: "Public Markets" },
  { num: "24", title: "Main Board Listing", desc: "Direct main-board IPO advisory for eligible enterprises — DRHP, SEBI liaison, roadshow and post-listing compliance.", tag: "Public Markets" },
  { num: "25", title: "Issue of Warrants", desc: "Warrant issuance structuring — pricing, conversion terms and SEBI ICDR alignment for strategic capital raises.", tag: "Equity" },
  { num: "26", title: "Corporate Structuring", desc: "Holding-company design, subsidiary layering, capital-table clean-ups and cross-border restructuring for tax and governance efficiency.", tag: "Advisory" },
];

export const advisoryBoard = [
  {
    name: "CS Keshav Daliya",
    role: "Advisory Board",
    credentials: null,
    phone: "+91 94224 57514",
    tel: "+919422457514",
    email: "keshav@mindscope.in",
    whatsapp: "https://wa.me/919422457514?text=Hello%20Keshav%2C%20I%20found%20you%20via%20mindscope.in",
    bio: "A seasoned Company Secretary and legal strategist with deep expertise in capital markets, corporate governance and SEBI regulation. Keshav has counselled listed and unlisted issuers across rights issues, buybacks and delisting mandates for over a decade.",
  },
  {
    name: "CS Mangesh More",
    role: "Advisory Board",
    credentials: null,
    phone: "+91 98909 16987",
    tel: "+919890916987",
    email: "mangesh@mindscope.in",
    whatsapp: "https://wa.me/919890916987?text=Hello%20Mangesh%2C%20I%20found%20you%20via%20mindscope.in",
    bio: "Corporate secretarial practitioner and compliance architect specialising in issuer readiness, board process and LODR frameworks. Mangesh has shepherded first-time issuers from private-limited scaffolding to public-market maturity.",
  },
];

export const boardMembers = [
  {
    name: "Darshana Malviya",
    role: "Board",
    bio: "Anchors the firm's ethics and governance charter. Darshana brings a decade of principled leadership in advisory mandates, translating regulatory intent into board-level clarity for founders and family offices.",
  },
  {
    name: "Pallavi Daliya",
    role: "Board",
    bio: "Directs firm-wide strategy and client stewardship. Pallavi has curated Mindscope's client-first philosophy — where discretion, cadence and outcome-fidelity are non-negotiable.",
  },
];

export const middleManagement = [
  {
    name: "Ujwala Chandak",
    role: "Head – Issuer Advisory",
    bio: "Leads issuer-side execution across IPO, rights and preferential mandates.",
  },
  {
    name: "Mansi Chandak",
    role: "Head – Compliance",
    bio: "Governs the LODR, insider-trading and disclosure calendar for all listed clients.",
  },
  {
    name: "Nisarg Shukla",
    role: "Head – Structured Finance",
    bio: "Structures NCD, QIP and hybrid instruments with institutional syndication.",
  },
  {
    name: "Shradha Karmore",
    role: "Head – Client Success",
    bio: "Owns the end-to-end client journey from mandate signing through post-listing stewardship.",
  },
];

export const stats = [
  { value: "All", label: "Capital Solutions", sub: "under one roof" },
  { value: "500+", label: "Clients Served", sub: "and counting" },
  { value: "10Y+", label: "Cumulative Practice", sub: "across the board" },
  { value: "1", label: "Client Cadence", sub: "always personal" },
];

export const testimonials = [
  {
    quote:
      "Mindscope translated what felt like a compliance thicket into a clean, staged capital plan. Our board received the same clarity we did.",
    author: "Promoter, Mid-cap listed manufacturer",
    context: "Rights Issue · 2024",
  },
  {
    quote:
      "The discretion was the differentiator. We spoke about a delisting for six months before the market noticed anything.",
    author: "Family Office Principal",
    context: "Voluntary Delisting · 2023",
  },
  {
    quote:
      "For a first-time issuer, they held the entire DRHP process together — SEBI, merchant bankers, and our own team.",
    author: "Founder & CEO, SME-to-Main Board migration",
    context: "IPO · 2025",
  },
];

export const clients = [
  { name: "Antra India Limited", sector: "Defence · Empowering the Armed Forces", logo: "/clients/antra-india.jpg" },
  { name: "Droneacharya Aerial Innovations", sector: "Drone Industry", logo: "/clients/droneacharya.jpg" },
  { name: "upGrad", sector: "EdTech", logo: "/clients/upgrad.png" },
  { name: "iSera Biological", sector: "Vaccines & Hormones", logo: "/clients/isera.jpg" },
  { name: "plus ninety one", sector: "HealthTech", logo: "/clients/plus-ninety-one.png" },
  { name: "Karan Kothari Jewellers", sector: "Jewellery · Pure and Timeless", logo: "/clients/kothari-jewellers.jpg" },
  { name: "Desi Farms", sector: "Milk & Dairy · Purity Guaranteed", logo: "/clients/desi-farms.jpg" },
  { name: "Virtual Galaxy", sector: "Technology", logo: "/clients/virtual-galaxy.png" },
  { name: "Nagpur Smart & Sustainable City Development Corporation Ltd", sector: "Smart City · Nagpur", logo: null },
  { name: "Asian Hospital Nagpur", sector: "Healthcare", logo: null },
  { name: "Bajaj Steel Industries Limited", sector: "Manufacturing", logo: null },
  { name: "Bajaj Global Limited", sector: "Conglomerate", logo: null },
  { name: "Tashi India Limited", sector: "Industrial", logo: null },
];

export const tocSections = [
  { num: "01", title: "The Mindscope Perspective", route: "/about" },
  { num: "02", title: "Corporate Heritage & Identity", route: "/about" },
  { num: "03", title: "Strategic Intent: Mission & Vision", route: "/vision" },
  { num: "04", title: "Our Core Philosophy", route: "/vision" },
  { num: "05", title: "Leadership & Governance", route: "/leadership" },
  { num: "06", title: "Service Ecosystem", route: "/services" },
];

export const principals = [
  { name: "Mangesh More", role: "Advisory Board", phone: "+91 98909 16987", tel: "+919890916987", email: "mangesh@mindscope.in", whatsapp: "https://wa.me/919890916987?text=Hello%20Mangesh%2C%20I%20found%20you%20via%20mindscope.in" },
  { name: "Keshav Daliya", role: "Advisory Board", phone: "+91 94224 57514", tel: "+919422457514", email: "keshav@mindscope.in", whatsapp: "https://wa.me/919422457514?text=Hello%20Keshav%2C%20I%20found%20you%20via%20mindscope.in" },
];

export const social = {
  linkedin: "https://www.linkedin.com/company/mindscope-advisor-llp/",
  facebook: "https://www.facebook.com/mindscope.in/",
  instagram: "https://www.instagram.com/mindscope.in/",
};


export const contact = {
  primaryEmail: "hello@mindscope.in",
  emails: ["mangesh@mindscope.in", "keshav@mindscope.in"],
  phones: [
    { name: "Mangesh More", number: "+91 98909 16987", tel: "+919890916987" },
    { name: "Keshav Daliya", number: "+91 94224 57514", tel: "+919422457514" },
  ],
  website: "www.mindscope.in",
  address: {
    line1: "710 / 711 / 712 A Wing, Lokmat Bhawan",
    line2: "Ramdaspeth, Nagpur 440010",
    line3: "Maharashtra, India",
  },
  hours: "Mon – Sat · 09:30 – 18:30 IST",
};

// Curated Unsplash images tuned to the deck's editorial navy + gold aesthetic
export const media = {
  heroBackdrop: "https://images.unsplash.com/photo-1519501025264-65ba15a82390?auto=format&fit=crop&w=1600&q=80",
  perspective: "https://images.unsplash.com/photo-1554469384-e58fac16e23a?auto=format&fit=crop&w=1400&q=80",
  identity: "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?auto=format&fit=crop&w=1400&q=80",
  whoWeAre: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1400&q=80",
  strategy: "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&w=1400&q=80",
  leadership: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=1400&q=80",
  chambers: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=80",
  closing: "https://images.unsplash.com/photo-1507646227500-4d389b0012be?auto=format&fit=crop&w=1600&q=80",
  ascent: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=1400&q=80",
};
